import emailjs from "@emailjs/browser";

const SERVICE_ID = "service_x0gbatf";
const PUBLIC_KEY = "LHN36zibZMdIZeRb7";

// Kept as direct constants, matching the SSDI EmailJS setup.
// Update an individual lander's IDs here when its dedicated EmailJS templates are created.
const ACA_ADMIN_TEMPLATE_ID = "template_kfgpz62";
const ACA_USER_TEMPLATE_ID = "template_ezpn5ab";
const AUTO_ADMIN_TEMPLATE_ID = "template_gsmyc3b";
const AUTO_USER_TEMPLATE_ID = "template_36iqkvb";
const FINAL_EXPENSE_ADMIN_TEMPLATE_ID = "template_ihj9a0k";
const FINAL_EXPENSE_USER_TEMPLATE_ID = "template_0qxlpjv";

emailjs.init(PUBLIC_KEY);

const templateParams = (formData, formType) => {
  const answerValues = Object.values(formData.answers);
  const submissionDateCST = new Date().toLocaleString("en-US", { timeZone: "America/Chicago", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true }) + " CST";
  return {
  title: `New ${formType} Inquiry`,
  name: formData.fullName,
  fullName: formData.fullName,
  full_name: formData.fullName,
  email: formData.email,
  phone: formData.phone,
  state: formData.state,
  answers: Object.entries(formData.answers).map(([question, answer]) => `${question}: ${answer}`).join("\n"),
  submissionDate: new Date().toLocaleString(),
  submissionDateCST,
  localTime: new Date().toString(),
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  page_source: window.location.href,
  form_type: formType,
  consentgiven: formData.consent ? "Yes" : "No",
  ip_address: formData.ipAddress || "",
  gclid: formData.gclid || "",
  gbraid: formData.gbraid || "",
  wbraid: formData.wbraid || "",
  certId: formData.trustedFormCertUrl || "",
  pingUrl: formData.trustedFormPingUrl || "",
  tokenUrl: formData.trustedFormToken || "",
  trustedFormCertUrl: formData.trustedFormCertUrl || "",
  trustedFormPingUrl: formData.trustedFormPingUrl || "",
  trustedFormToken: formData.trustedFormToken || "",
  q1: answerValues[0] || "N/A",
  q2: answerValues[1] || "N/A",
  q3: answerValues[2] || "N/A",
  q4: answerValues[3] || "N/A",
  q5: answerValues[4] || "N/A",
  q6: answerValues[5] || "N/A",
  q7: answerValues[6] || "N/A",
  };
};

const send = (adminTemplate, userTemplate, formType, formData) => Promise.all([
  emailjs.send(SERVICE_ID, adminTemplate, templateParams(formData, formType)),
  emailjs.send(SERVICE_ID, userTemplate, templateParams(formData, formType)),
]);

export const sendAcaInsuranceEmails = (formData) => send(ACA_ADMIN_TEMPLATE_ID, ACA_USER_TEMPLATE_ID, "ACA Health Insurance Landing Page", formData);
export const sendAutoInsuranceEmails = (formData) => send(AUTO_ADMIN_TEMPLATE_ID, AUTO_USER_TEMPLATE_ID, "Auto Insurance Landing Page", formData);
export const sendFinalExpenseInsuranceEmails = (formData) => send(FINAL_EXPENSE_ADMIN_TEMPLATE_ID, FINAL_EXPENSE_USER_TEMPLATE_ID, "Final Expense Insurance Landing Page", formData);
